<app-banner [loading]="loading" [updating]="downloading" [info]="true" heading="Exceptional circumstance" [subHeading]="subHeading"
  [dynamicHeading]="true">

  <div class="toolbar-content">

    @if (!loading) {
      <div class="assigned-to btn" [class.active]="assigning" (click)="assigning=true">
        <i class="fa fa-user"></i>
        <app-ext-circ-assign [item]="item" (selected)="assigning = !!$event" [selecting]="assigning"></app-ext-circ-assign>
      </div>
    }

    <button (click)="print()" aria-label="Back to list" class="btn">
      <i class="fa fa-print"></i>
      <span>print</span>
    </button>
    <button (click)="exit()" aria-label="Back to list" class="btn btn-back">
      <i class="fa fa-close"></i>
      <span>close</span>
    </button>
  </div>

</app-banner>

@if (item && !loading) {
  <div class="content fadein">
    <div class="row">
      <div class="col-lg-7 left-col">
        @if (previousECRecord===true) {
          <section>
            <div style="display:flex">
              <p class="important" style="width:100%;text-align: center;">This user has submitted exceptional circumstances in past three years</p>
            </div>
          </section>
        }
        <section class="section-to-print">
          <div class="print-only" style="margin-top:-200px">
            <h1>Exceptional Circumstances</h1>
            <p class="intro-text">{{subHeading}}</p>
            <hr/>
          </div>
          <div style="display:flex">
            <h2 style="flex-grow:1">{{item.subject}}</h2>
            <div class="status {{ReviewStatus[item.review.status]}}">
            {{ ReviewStatus[item.review.status] | caseSplit  }}</div>
          </div>
          <div class="ext-circ-form" >
            @for (questionGroup of form.questionGroups; track questionGroup) {
              <div>
                @for (question of questionGroup.questions; track question) {
                  <app-form-question [form]="form" [question]="question" [readonly]="true">
                  </app-form-question>
                }
              </div>
            }
          </div>
        </section>
        <section>
          <h2>Supporting documents</h2>
          <div>
            <ul class="documents">
              @for (proof of item.proofs; track proof) {
                <li>
                  <a (click)="download(proof)">
                    <i [class]="getIcon(proof)"></i>
                    <div class="filename">{{proof.filename}}</div>
                    <i class="fa fa-download"></i>
                  </a>
                </li>
              }
            </ul>
          </div>
        </section>
      </div>
      <div class="col-lg-5 right-col no-print">
        @if (!loading && !completed) {
          <section>
            <h2>Recommendation</h2>
            <app-ext-circ-request [type]="item.type" [request]="review.reviewer" [isDecision]="false" [readonly]="completed"></app-ext-circ-request>
            <div class="form-group" style="margin-top:20px;">
              <label for="decisionMessage">Message to registrant</label>
              <app-text-editor [(ngModel)]="review.messageToRegistrant" placeholder="Enter text to display on the registrant's notice of decision" name="decisionMessage" [readonly]="completed">
              </app-text-editor>
            </div>
            <button class="btn btn-lg btn-block btn-primary" [disabled]="!validRecommendation || savingRecommendation" (click)="saveRecommendation()">{{ savingRecommendation ? 'Saving...' : 'Save recommendation'}}</button>
          </section>
        }
        @if (!loading && showDecision) {
          <section>
            <h2>Decision</h2>
            <app-ext-circ-request  [type]="item.type" [request]="review.manager" [isDecision]="isDecision" [readonly]="completed"></app-ext-circ-request>
            <div class="form-group" style="margin-top:20px;">
              <label for="decisionMessage">Message to registrant</label>
              <app-text-editor [(ngModel)]="review.messageToRegistrant" placeholder="Enter text to display on the registrant's notice of decision" name="decisionMessage" [readonly]="completed">
              </app-text-editor>
            </div>
            @if (!completed) {
              <button class="btn btn-lg btn-block btn-primary" [disabled]="!validDecision || savingDecision" (click)="saveDecision()">{{ savingDecision ? 'Saving...' : 'Save decision'}}</button>
            }
            @if (!completed) {
              <button  class="btn btn-lg btn-block btn-primary" [disabled]="!validDecision || submittingDecision" (click)="submitDecision()">{{ submittingDecision ? 'Submitting...' : 'Submit'}}</button>
            }
          </section>
        }
      </div>
    </div>
  </div>
}